<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-user-check text-white text-4xl"></i>
      </div>
    </div>
    <div class="px-6 text-center">
      <h2 class="text-2xl font-bold mb-2 mt-2">Ti stai candidando<br/>come {{ user ? user.nome : '' }}</h2>
      <p class="text-gray-500 mb-6">Hai effettuato l'accesso come {{ user ? user.nome : '' }} {{ user ? user.cognome : '' }}.<br>Sei sicuro di voler continuare?</p>
      <CuButton primary class="w-full mb-2" @click="$emit('proceed')">Prosegui</CuButton>
      <div class="text-gray-400 text-sm mt-2">
        Non sei tu?
        <a href="#" class="text-primary font-semibold ml-1" @click.prevent="$emit('logout')">Esci</a>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "CandidateModal",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false },
    user: { type: Object, default: null }
  },
  mounted() {
    console.log(this.user)
  },
}
</script>
